import Toolbar from '@material-ui/core/Toolbar';
import styled from '@emotion/styled';

export const StyledToolbar = styled(Toolbar)`
  justify-content: space-between;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const NavContainer = styled.div`
  margin-left: 25px;
`;
